"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetTeammatesListQuery = exports.useGetUserTeamsExcludeArchivedQuery = exports.useGetUserTeamsQuery = exports.users = exports.usersTeammatesAdapter = exports.usersTeamsAdapter = void 0;

var _toolkit = require("@reduxjs/toolkit");

var _EmptyAppApi = require("../EmptyAppApi");

var usersTeamsAdapter = (0, _toolkit.createEntityAdapter)();
exports.usersTeamsAdapter = usersTeamsAdapter;
var usersTeammatesAdapter = (0, _toolkit.createEntityAdapter)({
  selectId: function selectId(user) {
    return user.userId;
  }
});
exports.usersTeammatesAdapter = usersTeammatesAdapter;

var users = _EmptyAppApi.emptyAppApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getUserTeams: build.query({
        query: function query() {
          return "/api/v1/users/teams";
        },
        transformResponse: function transformResponse(response) {
          return usersTeamsAdapter.addMany(usersTeamsAdapter.getInitialState(), response.data);
        }
      }),
      getUserTeamsExcludeArchived: build.query({
        query: function query() {
          return "/api/v1/users/teams?includeArchived=false";
        },
        transformResponse: function transformResponse(response) {
          return usersTeamsAdapter.addMany(usersTeamsAdapter.getInitialState(), response.data);
        }
      }),
      getTeammatesList: build.query({
        query: function query() {
          return '/api/v1/users/teammates-list';
        },
        transformResponse: function transformResponse(response) {
          return usersTeammatesAdapter.addMany(usersTeammatesAdapter.getInitialState(), response.data);
        }
      })
    };
  }
});

exports.users = users;
var useGetUserTeamsQuery = users.useGetUserTeamsQuery,
    useGetUserTeamsExcludeArchivedQuery = users.useGetUserTeamsExcludeArchivedQuery,
    useGetTeammatesListQuery = users.useGetTeammatesListQuery;
exports.useGetTeammatesListQuery = useGetTeammatesListQuery;
exports.useGetUserTeamsExcludeArchivedQuery = useGetUserTeamsExcludeArchivedQuery;
exports.useGetUserTeamsQuery = useGetUserTeamsQuery;